import { splitReducer } from '@splitsoftware/splitio-redux';
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { routerReducer } from 'react-router-redux';
import { addressReducer } from './address';
import { appReducer } from './app';
import { eventReducer } from './event';
import { expressCheckoutReducer } from './expressCheckout';
import { googlePayReducer } from './googlePay';
import { groupRegistrationReducer } from './groupRegistration';
import { orderReducer } from './order';
import { organizerReducer } from './organizer';
import { paymentHistoryReducer } from './paymentHistory';
import { paypalReducer } from './paypal';
import pickASeatReducer from './pickASeat';
import { seriesReducer } from './series';
import { statsigReducer } from './statsig';
import { surveyReducer } from './survey';
import tokensReducer from './tokens';
import { ticketsReducer } from './tickets';
import { timerReducer } from './timer';
import { userReducer } from './user';
import { waitingRoomReducer } from './waitingRoom';
import { applepayReducer } from './applePay';

const gaSettings = (state = {}) => state;

export default combineReducers({
    address: addressReducer,
    app: appReducer,
    event: eventReducer,
    expressCheckout: expressCheckoutReducer,
    form: formReducer,
    googlePay: googlePayReducer,
    groupRegistration: groupRegistrationReducer,
    order: orderReducer,
    organizer: organizerReducer,
    paymentHistory: paymentHistoryReducer,
    paypal: paypalReducer,
    pickASeat: pickASeatReducer,
    routing: routerReducer,
    series: seriesReducer,
    splitio: splitReducer,
    statsig: statsigReducer,
    tickets: ticketsReducer,
    timer: timerReducer,
    tokens: tokensReducer,
    user: userReducer,
    survey: surveyReducer,
    waitingRoom: waitingRoomReducer,
    applepay: applepayReducer,
    gaSettings,
});
